import { Lock, Share2 } from "lucide-react";
import { useEffect } from "react";

import { attentionSelector, designate } from "../components/attention";
import { Banner } from "../components/Callout";
import { Presence } from "../components/presence";
import { Button } from "../components/ui";
import { t } from "../i18n/i18n";
import { isOwner, isShared, SHARE_TARGET, useOpenDossier, useSharing } from "./access";

/** DIREX d'un dossier qui n'est partagé à personne (docs/17 §3.1, §3.7, §8.3) : avis au propriétaire, « Partager… »
 *  dans l'avis, et le « Partager… » de la barre latérale clignote comme action attendue. Rien en mode hérité, ni pour
 *  un dossier de l'unité ou déjà partagé. */
export function PrivateDirexBanner() {
  const exercise = useOpenDossier();
  const open = useSharing((s) => s.open);
  const shown = Boolean(exercise && exercise.access && !exercise.unit_item && isOwner(exercise) && !isShared(exercise));
  useEffect(() => {
    if (!shown) return;
    const timer = window.setTimeout(() => designate(attentionSelector(SHARE_TARGET)), 600);
    return () => window.clearTimeout(timer);
  }, [shown]);
  return (
    <Presence show={shown}>
      {shown && exercise && (
        <Banner
          tone="warn"
          icon={Lock}
          actions={
            <Button size="sm" variant="secondary" onClick={() => open(exercise)}>
              <Share2 size={14} /> {t("Partager…")}
            </Button>
          }
        >
          {t("Dossier privé : vous seul voyez cette DIREX. Partagez le dossier avec les participants : Modification pour l'animation, les cellules et les observateurs qui notent la 3A, Lecture seule pour ceux qui suivent sans écrire.")}
        </Banner>
      )}
    </Presence>
  );
}
